import React from 'react';
import Svg, { Path } from 'react-native-svg';

export interface AgeRestrictedMissionIconProps {
  size?: number;
  color: string;
}

const AgeRestrictedMissionIcon = ({ size = 36, color }: AgeRestrictedMissionIconProps) => (
  <Svg width={size} height={size} viewBox="0 0 640 640" fill="none">
    <Path
      fill={color}
      opacity={0.4}
      d="M48 576C56.8 576 64 568.8 64 560L64 544C64 464.5 128.5 400 208 400L272 400C351.5 400 416 464.5 416 544L416 560C416 568.8 423.2 576 432 576L48 576zM336 192C336 245 293 288 240 288C187 288 144 245 144 192C144 139 187 96 240 96C293 96 336 139 336 192z"
    />
    <Path
      fill={color}
      d="M240 288C293 288 336 245 336 192C336 139 293 96 240 96C187 96 144 139 144 192C144 245 187 288 240 288zM240 64C310.7 64 368 121.3 368 192C368 262.7 310.7 320 240 320C169.3 320 112 262.7 112 192C112 121.3 169.3 64 240 64zM208 400C128.5 400 64 464.5 64 544L64 560C64 568.8 56.8 576 48 576C39.2 576 32 568.8 32 560L32 544C32 446.8 110.8 368 208 368L272 368C369.2 368 448 446.8 448 544L448 560C448 568.8 440.8 576 432 576C423.2 576 416 568.8 416 560L416 544C416 464.5 351.5 400 272 400L208 400zM375.3 304.6C382.1 296.4 388.3 287.5 393.5 278.2C404.9 284.5 418 288.1 432 288.1C476.2 288.1 512 252.3 512 208.1C512 163.9 476.2 128.1 432 128.1C422.8 128.1 413.9 129.7 405.7 132.5C402 122.3 397.5 112.6 392.1 103.4C404.5 98.7 418 96.1 432 96.1C493.9 96.1 544 146.2 544 208.1C544 270 493.9 320 432 320C411.3 320 391.9 314.4 375.3 304.6zM457.4 418.2C449 405.9 439.4 394.4 428.8 384L432 384C529.2 384 608 462.8 608 560C608 568.8 600.8 576 592 576C583.2 576 576 568.8 576 560C576 489.1 524.8 430.2 457.4 418.2z"
    />
  </Svg>
);

export default AgeRestrictedMissionIcon;
